module.exports = "<small>\n    {{ suppressionCtrl._scope.suppression.created_at }}  -  {{ suppressionCtrl.getMessage() }}\n    </br>\n</small>\n";